import React, { useState } from "react";

type AuthContextType = {
  userInfo: any;
  setUserInfo?: any;
};

type Props = {
  children: any;
};

export const AuthContext = React.createContext<AuthContextType>({
  userInfo: null,
});

export function AuthProvider({ children }: Props) {
  let user: any = localStorage.getItem("userData");
  user = user ? JSON.parse(user) : null;
  const [userInfo, setUserInfo] = useState<any>(user);
  const value = { userInfo, setUserInfo };

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
}
